import { dashboardApi } from '@/store/api/base/api.base';
import { writeCompany } from '@/store/api/company/company.cache';
import type { TypeCompany, TypeCompanyInput } from '@/types/company/types.company';

export const companyApi = dashboardApi.injectEndpoints({
    endpoints: (build) => ({
        readCompany: build.query<TypeCompany, void>({
            query: () => ({ url: '/company' }),
            providesTags: ['Company'],
        }),

        createCompany: build.mutation<TypeCompany, TypeCompanyInput>({
            query: (company) => ({ url: '/company', method: 'post', data: { company } }),
            onQueryStarted: async (_input, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                    writeCompany(dispatch, data);
                } catch {
                    return;
                }
            },
        }),

        updateCompany: build.mutation<TypeCompany, { company: TypeCompanyInput; revision: number }>({
            query: ({ company, revision }) => ({ url: '/company', method: 'patch', data: { company, revision } }),
            onQueryStarted: async (_input, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled;
                    writeCompany(dispatch, data);
                } catch {
                    return;
                }
            },
        }),
    }),
});

export const { useReadCompanyQuery, useCreateCompanyMutation, useUpdateCompanyMutation } = companyApi;

export default companyApi;
